<template>
 <v-dialog
    v-model="show"
    max-width="1000">
    <v-card
      v-if="show">
        <v-toolbar short dark color="primary">
          <v-btn icon dark @click="cancel">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
              {{$t("common.search")}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="searchParamsValid" class="mx-3 mt-2">
            <v-row align="center" class="mt-3">
              <v-col cols=12 md=6>
                <v-select
                  :items="operators"
                  v-model="editableSearchParams.companyId"
                  label="Id"
                ></v-select>
              </v-col>
              <v-col cols=12 md=6>
                <v-select
                  :items="bookingStatuses"
                  v-model="editableSearchParams.bookingStatus"
                  label="Booking Status"
                >
                  <template v-slot:selection="{ item }">
                    {{ bookingStatusToString(item) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ bookingStatusToString(item) }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="search">
              {{$t("common.search")}}
            </v-btn>
            <v-btn
              @click="cancel"
              class="ml-2">
              {{$t("common.cancel")}}
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { BookingStatus, BookingStatusToString } from "../../../models/BookingStatus";
import _ from "lodash";

export default {
    props: {
        show: Boolean,
        searchParams: Object
    },
    data() {
        return {
            editableSearchParams: _.cloneDeep(this.searchParams),
            searchParamsValid: true,
            bookingStatuses: Object.values(BookingStatus)
        };
    },
    computed: {
        operators() {
            return this.$store.state.user.operators;
        }
    },
    methods: {
        search() {
            let params = _.cloneDeep(this.editableSearchParams);
            this.$emit("search", params);
        },
        cancel() {
            this.searchParams = this.searchParams;
            this.$emit("close");
        },
        bookingStatusToString(status) {
            return BookingStatusToString(status);
        }
    }
};
</script>
